import { render, staticRenderFns } from "./institutionWorkDetail.vue?vue&type=template&id=63a0954a&scoped=true"
import script from "./institutionWorkDetail.vue?vue&type=script&lang=js"
export * from "./institutionWorkDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=63a0954a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0954a",
  null
  
)

export default component.exports